<template>
    <bill-shell>
        <section class="py-5 pb-3 bg-white">
            <ZesaCalculatorContent v-if="activeCalculator === 'zesa-calculator'" />
            <CurrencyExchangeContent v-if="activeCalculator === 'currency-calculator'" />
            <LoanCalculatorContent v-if="activeCalculator === 'loan-calculator'" />
            <SavingsCalculatorContent v-if="activeCalculator === 'savings-calculator'" />
            <MortgageCalculatorContent v-if="activeCalculator === 'mortgage-calculator'" />
            <SolarSavingsCalculatorContent v-if="activeCalculator === 'solar-savings-calculator'" />
        </section>
    </bill-shell>
</template>

<script>
import BillShell from "../bill-shell.vue";
import ZesaCalculatorContent from "./zesa/ZesaCalculatorContent.vue";
import CurrencyExchangeContent from "./currency-exchange-rate/CurrencyExchangeContent.vue";
import LoanCalculatorContent from "./loan/LoanCalculatorContent.vue";
import SavingsCalculatorContent from "./savings-growth/SavingsCalculatorContent.vue";
import MortgageCalculatorContent from "./mortgage/MortgageCalculatorContent.vue";
import SolarSavingsCalculatorContent from "./solar-savings/SolarSavingsCalculatorContent.vue";

export default {
    name: "CalculatorsShell",
    components: {
        BillShell,
        ZesaCalculatorContent,
        CurrencyExchangeContent,
        LoanCalculatorContent,
        SavingsCalculatorContent,
        MortgageCalculatorContent,
        SolarSavingsCalculatorContent

    },

    data() {
        return {
            activeCalculator: null, // Tracks the currently active calculator
        };
    },

    watch: {
        // Watch for route changes to update the activeCalculator
        $route: "updateActiveCalculator",
    },

    mounted() {
        // Set the initial calculator on component mount
        this.updateActiveCalculator();
    },

    methods: {
        updateActiveCalculator() {
            // Extract the last segment of the path as the active calculator
            const calculatorType = this.$route.path.split("/").pop();

            // Validate and assign active calculator
            const validCalculators = [
                "zesa-calculator",
                "currency-calculator",
                "loan-calculator",
                "savings-calculator",
                "mortgage-calculator",
                "solar-savings-calculator",
            ];

            this.activeCalculator = validCalculators.includes(calculatorType) ? calculatorType : null;
        },

        formatTitle(calculator) {
            // Capitalize and format the calculator name for the title
            return calculator
                .split("-")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
        },
    },
};
</script>

